(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bottom-nav-mobile"] && !Shopify.designMode) return;
  try {
    (function() {
  var btn = document.querySelector('[data-bn-search]');
  if (btn) {
    btn.addEventListener('click', function() {
      var search = document.querySelector('input[type="search"], input[name="q"]');
      if (search) {
        search.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() { search.focus(); }, 400);
      } else {
        window.location.href = '/search';
      }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
